<div class="row">
  <a class="game-box"  href="{{game.link}}" *ngFor="let game of games">
    <div class="game-box-background" [style.background]="'url('+game.img+')'"></div>
    <h1 class="game-box-title">{{game.title}}
      <span class="ts-color-white">{{game.legend}}</span>
    </h1>
    <a class="game-box-btn ts-background-{{game.theme}}">
      <span style="transform: rotate(45deg);">
        <svg xmlns="http://www.w3.org/2000/svg" width="46.669" height="46.669" viewBox="0 0 46.669 46.669">
          <g id="close" transform="translate(-41.665 -25.665)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="60" height="6"
              transform="translate(45.908 25.665) rotate(45)" fill="#fff" />
            <rect id="Rectángulo_41" data-name="Rectángulo 41" width="60" height="6"
              transform="translate(88.334 29.908) rotate(135)" fill="#fff" />
          </g>
        </svg>
      </span>

    </a>
  </a>
</div>
